import { inject } from 'aurelia-framework';
import { HttpClient, json } from 'aurelia-fetch-client';
import { toTitleCase } from 'resources/utility';

@inject(HttpClient)
export class FavoriteService {
    favorites = [];

    constructor(http) {
        this.http = http;
    }

    async loadFavorites() {
        const response = await this.http.fetch('users/favorite-pages');
        this.favorites = await response.json();
        this.favorites = this.favorites.map(x => ({ ...x, name: toTitleCase(x.name), path: x.path.toLowerCase() }));
        this.sort();
    }

    async addFavorite(name, path) {
        await this.http.fetch('users/favorite-pages', { method: 'POST', body: json({ name, path }) });
        this.favorites.push({ name, path });
        this.sort();
    }

    async removeFavorite(path) {
        await this.http.fetch('users/favorite-pages', { method: 'DELETE', body: json({ path })});
        this.favorites = this.favorites.filter(x => x.path !== path);
        this.sort();
    }

    sort() {
        this.favorites.sort((a, b) => a.name == b.name ? 0 : a.name > b.name ? 1 : -1);
    }
}